jQuery(document).ready(function (e) {
    initScript();

    $(function () {
        var $carousel = $('.jdgm-widget.jdgm-cards-carousel');

        if (!$carousel.children('.container-fluid').length) {
            $carousel.wrapInner('<div class="container-fluid"></div>');
        }
    });
    setTimeout(function () {
        jQuery('body').addClass('loaded');
    }, 10);
});

var e = 0;
jQuery(window).scroll(function () {

    var t = jQuery(window).scrollTop(),
        n = window.pageYOffset || document.documentElement.scrollTop;
    n > e && t > 50 ? (jQuery(".site-header").addClass("header-away")) : jQuery(".site-header").removeClass("header-away"), e = n <= 0 ? 0 : n

}), jQuery(document).on("mousemove", function (e) {
    e.clientY < 100 && jQuery(".site-header").removeClass("header-away");
})

function initScript() {
    commonScripts();
    initParallax();
}

function commonScripts() {

    $(window).on('scroll load', function () {
        if ($(window).scrollTop() > 50) {
        $('header.site-header').addClass('header-scrolled');
        } else {
        $('header.site-header').removeClass('header-scrolled');
        }
    });

    var $header = $('header.site-header');

    function checkSliderHeaderClass() {
        var scrollTop = $(window).scrollTop();
        var headerHeight = $header.outerHeight() || 0;

        var addFixed = false;
        var addEnded = false;

        $('slider-component').each(function () {
        var $slider = $(this);
        var sliderTop = $slider.offset().top;
        var sliderBottom = sliderTop + ( $slider.outerHeight() - 600 );

        if (
            scrollTop > 100 &&
            scrollTop + headerHeight >= sliderTop &&
            scrollTop + headerHeight < sliderBottom
        ) {
            addFixed = true;
            addEnded = false;
            return false;
        }

        if (
            scrollTop > 100 &&
            scrollTop + headerHeight >= sliderBottom
        ) {
            addFixed = false;
            addEnded = true;
        }
        });

        $header.toggleClass('fixed-leaf', addFixed);
        $header.toggleClass('slider-ended', addEnded);
    }

    $(window).on('scroll resize load', checkSliderHeaderClass);
    checkSliderHeaderClass();

    // smooth scroll
    const lenis = new Lenis({
        duration: 1.6,
        smoothWheel: true,
        smoothTouch: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    function updateLenis() {
        if (lenis && typeof lenis.resize === 'function') {
        lenis.resize();
        }
    }

    // Normal page load / resize
    $(window).on('load resize', function () {
        updateLenis();

        setTimeout(updateLenis, 300);
        setTimeout(updateLenis, 800);
        setTimeout(updateLenis, 1500);
    });

    // Shopify AJAX related products load
    $('product-recommendations').each(function () {
        const target = this;

        const observer = new MutationObserver(function () {
        updateLenis();

        setTimeout(updateLenis, 300);
        setTimeout(updateLenis, 800);
        });

        observer.observe(target, {
        childList: true,
        subtree: true
        });
    });

    // Image lazy-load fix
    $('img').on('load', function () {
        updateLenis();
    });

    // Swiper / layout late update fix
    setTimeout(updateLenis, 500);
    setTimeout(updateLenis, 1000);
    setTimeout(updateLenis, 2000);
    // end smooth scroll

    $(document).on('click', '.quick-add button, .quick-add__submit', function () {
        var $item = $(this).closest('li.grid__item');

        $(this).blur();
        $item.addClass('quick-add-hide');

        $item.one('mouseleave', function () {
            $item.removeClass('quick-add-hide');
        });
    });

    $(document).on('click', 'a.scroll-down', function (e) {
        e.preventDefault();

        var $currentSection = $(this).closest('.shopify-section');
        var $nextSection = $currentSection.next('.shopify-section');

        if ($nextSection.length) {
            $('html, body').animate({
            scrollTop: $nextSection.offset().top
            }, 600);
        }
    });

    var $price = $('section.signature-product .product-info > p.price');

    if ($('section.signature-product .product-info form .cloned-price').length === 0) {
        $price.clone()
            .removeClass('js-price') // optional (avoid conflicts)
            .addClass('cloned-price mobile-price')
            .appendTo('section.signature-product .product-info form');
    }

    $('.footer-columns h3.acco-heading').on('click', function () {
        var $h3 = $(this);
        var $ul = $h3.next('ul');

        $('.footer-columns h3.acco-heading').not($h3).removeClass('active')
            .next('ul').removeClass('active').slideUp(300);

        if ($h3.hasClass('active')) {
            $h3.removeClass('active');
            $ul.removeClass('active').slideUp(300);
        } else {
            $h3.addClass('active');
            $ul.addClass('active').slideDown(300);
        }
    });

    $('#HeaderDrawer .header-drawer__menus .drawer-menu .drawer-menu__heading').on('click', function () {
        $(this).closest('.header-drawer__menus').find('.drawer-menu > ul').removeClass('active');
        $(this).next('ul').addClass('active');
    });

    $('#HeaderDrawer .header-drawer__menus .drawer-menu ul span.back').on('click', function () {
        $(this).closest('ul').removeClass('active');
    });

    $(function () {
        function addInnerBannerClass() {
            if ($(window).width() <= 749) {
            if ($('body.product-page').find('.page-width').length) {
                $('body.product-page .page-width').addClass('inner-page-banner');
            }
            } else {
            $('body.product-page .page-width').removeClass('inner-page-banner');
            }
        }

        addInnerBannerClass();

        $(window).on('resize', function () {
            addInnerBannerClass();
        });
    });

    $(function () {
        $('.page-content').each(function (sectionIndex) {
            const $section = $(this);
            const $tocList = $('.faq-toc__list');

            const $headings = $section
            .find('h2, h3, h4')
            .filter(function () {
                return $(this).text().trim() && !$(this).closest('.faq-item').length;
            });

            const links = [];

            function closeAllFaqItems() {
            $section.find('.faq-item').each(function () {
                const $item = $(this);
                const $btn = $item.find('.faq-question').first();
                const $ans = $item.find('.faq-answer').first();
                const $icon = $item.find('.faq-question__icon').first();
                const $img = $item.find('.faq-question__icon img').first();

                const plus = $icon.data('plus') || $img.attr('src');

                $btn.attr('aria-expanded', 'false');
                $ans.stop(true, true).slideUp(250);
                $img.attr('src', plus);
            });
            }

            if ($tocList.length && $headings.length) {
                $headings.each(function (i) {
                    const $heading = $(this);
                    const id = `toc-${sectionIndex}-${i}`;
                    const text = $heading.attr('aria-label') || $heading.text().trim();

                    if (!text) return;

                    $heading.attr('id', id);

                    const $link = $('<a>', {
                        href: `#${id}`,
                        text: text
                    });

                    $tocList.append($('<li>').append($link));
                    links.push($link);

                    $link.on('click', function (e) {
                        e.preventDefault();

                        closeAllFaqItems();

                        if ($(window).width() <= 991) {
                            $('.tableof-contents .sub-heading').removeClass('active');
                            $('.tableof-contents .faq-toc').stop(true, true).slideUp(300);
                        }

                        $('html, body').animate({
                            scrollTop: $heading.offset().top - 100
                        }, 400);

                        links.forEach(($l) => $l.removeClass('active'));
                        $link.addClass('active');
                    });
            });

            const setActive = () => {
                let current = -1;

                $headings.each(function (i) {
                if ($(this).offset().top - $(window).scrollTop() <= 120) {
                    current = i;
                }
                });

                if (current > -1) {
                links.forEach(($l) => $l.removeClass('active'));
                links[current].addClass('active');
                }
            };

            $(window).on('scroll resize', setActive);
            setActive();
            }

            $section.find('.faq-item').each(function () {
                const $item = $(this);
                const $btn = $item.find('.faq-question').first();
                const $ans = $item.find('.faq-answer').first();
                const $img = $item.find('.faq-question__icon img').first();
                const $icon = $item.find('.faq-question__icon').first();

                const plus = $icon.data('plus') || $img.attr('src');
                const minus = $icon.data('minus') || plus;

                $ans.hide();
                $btn.attr('aria-expanded', 'false');

                $btn.on('click', function (e) {
                    e.preventDefault();

                    const isOpen = $btn.attr('aria-expanded') === 'true';

                    $section.find('.faq-item').not($item).each(function () {
                        const $otherItem = $(this);
                        const $otherBtn = $otherItem.find('.faq-question').first();
                        const $otherAns = $otherItem.find('.faq-answer').first();
                        const $otherIcon = $otherItem.find('.faq-question__icon').first();
                        const $otherImg = $otherItem.find('.faq-question__icon img').first();

                        const otherPlus = $otherIcon.data('plus') || $otherImg.attr('src');

                        $otherBtn.attr('aria-expanded', 'false');
                        $otherAns.stop(true, true).slideUp(250);
                        $otherImg.attr('src', otherPlus);
                    });

                    if (isOpen) {
                        $btn.attr('aria-expanded', 'false');
                        $ans.stop(true, true).slideUp(250);
                        $img.attr('src', plus);
                    } else {
                        $btn.attr('aria-expanded', 'true');
                        $ans.stop(true, true).slideDown(250);
                        $img.attr('src', minus);
                    }
                });
            });
        });
    });

    (function check($) {
        if (!$) return setTimeout(() => check(window.jQuery), 50);

        $(document).on('click', '.tableof-contents .sub-heading', function () {
            $(this).toggleClass('active');
            $(this).siblings('.faq-toc').stop(true, true).slideToggle(300);
        });

    })(window.jQuery);

    $(document).on('click', 'section.article-single ul.faq-toc__list li a', function () {
        if ($(window).width() <= 991) {
            var $section = $(this).closest('section.article-single');

            $section.find('.tableof-contents .sub-heading').removeClass('active');
            $section.find('.tableof-contents .faq-toc').stop(true, true).slideUp(300);
        }
    });

    $(document).on('click', '.mobile-facets__open-wrapper', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '.mobile-facets__disclosure', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '.mobile-facets__close', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeMobileFacets();
    });

    $(document).on('click', function () {
        if ($('.mobile-facets__disclosure[open]').length) {
            closeMobileFacets();
        }
    });

    function closeMobileFacets() {
        var $details = $('.mobile-facets__disclosure[open]');

        if (!$details.length) return;
        $details.removeClass('menu-opening');
        setTimeout(function () {
            $details.removeAttr('open');
        }, 500);
    }

    // journal accordion mobile
    function blogFilterAccordion() {
        if ($(window).width() <= 767) {
            $('.blog-listing__filters').each(function () {
            var $wrap = $(this);
            var $buttons = $wrap.find('.blog-listing__filter');
            var $first = $buttons.first();

            $first.off('click.blogAccordion').on('click.blogAccordion', function (e) {
                e.preventDefault();

                $wrap.toggleClass('is-open');
                $buttons.not(':first').stop(true, true).slideToggle(250);
            });

            $buttons.not(':first').off('click.blogClose').on('click.blogClose', function () {
                $wrap.removeClass('is-open');
                $buttons.not(':first').stop(true, true).slideUp(250);
            });

            if (!$wrap.hasClass('is-open')) {
                $buttons.not(':first').hide();
            }
            });
        } else {
            $('.blog-listing__filters').removeClass('is-open');
            $('.blog-listing__filter')
            .show()
            .off('click.blogAccordion click.blogClose');
        }
        }

        blogFilterAccordion();

        $(window).on('resize', function () {
        blogFilterAccordion();
    });

}

$(document).on('DOMSubtreeModified', 'section.signature-product .product-info > p.price', function () {
    var html = $(this).html();

    $('section.signature-product .product-info form .cloned-price')
        .html(html);
});

function initParallax() {
    $(window).on("load", function () {

    gsap.utils.toArray(".image-wrapper").forEach(function (container) {

        const img = container.querySelector("img");

        gsap.set(img, {
            yPercent: -20,
            scale: 1.2,
            force3D: true
        });

        gsap.to(img, {
            yPercent: 20,
            ease: "none",
            immediateRender: false,
            scrollTrigger: {
                trigger: container,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                invalidateOnRefresh: true
            }
        });

    });

    ScrollTrigger.refresh();
});
}

function moveElements(e) {
    var $arrow = $('a.scroll-down');

    var $heroMobile = $('#hero_video');
    var $heroDesktop = $('.hero-banner-content');

    if (e.matches) {
        if (!$arrow.parent().is($heroMobile)) {
            $arrow.appendTo($heroMobile);
        }
    } else {
        if (!$arrow.parent().is($heroDesktop)) {
            $arrow.appendTo($heroDesktop);
        }
    }
}

var mq = window.matchMedia("(max-width: 767px)");
moveElements(mq);
mq.addEventListener('change', moveElements);

function initMobileFacetShowMore() {
    $('.mobile-facets__submenu ul.mobile-facets__list').each(function () {
        var $list = $(this);
        var $items = $list.find('li.mobile-facets__item');

        $list.next('.read-more').remove();
        $items.show();

        if ($items.length > 2) {
            $items.slice(2).hide();

            $list.after(`
        <div class="read-more">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 3.75V11.25M9.5 7.5H2" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Show More</span>
        </div>
      `);
        }
    });
}

$(document).ready(function () {
    initMobileFacetShowMore();
});

$(document).on('click', '.read-more', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var $list = $btn.prev('ul.mobile-facets__list');
    var $items = $list.find('li.mobile-facets__item').slice(2);

    $items.slideToggle(300);
    $btn.toggleClass('is-active');

    $btn.find('span').text($btn.hasClass('is-active') ? 'Show Less' : 'Show More');
});

$(document).on('change', '.mobile-facets input', function () {
    setTimeout(function () {
        initMobileFacetShowMore();
    }, 2500);
});

function initRelatedProductsSlider() {
  $('.related-products__slider').each(function () {
    if (this.swiper) return;

    new Swiper(this, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 2.1
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  });
}

$(document).ready(function () {
  initRelatedProductsSlider();

  var observer = new MutationObserver(function () {
    initRelatedProductsSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

 var swiperEl = $('.how-it-works-grid .swiper')[0];

if (swiperEl) {
    new Swiper(swiperEl, {
        slidesPerView: 1.25,
        spaceBetween: 10,

        breakpoints: {
            560: {
                slidesPerView: 2.25,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    });
}

var interleaveOffset = 1;
function applyParallax(swiper) {
    if (!swiper.slides || !swiper.slides.length) return;

    $(swiper.slides).each(function () {
        var inner = $(this).find(".slide-inner")[0];
        if (!inner) return;

        var progress = parseFloat($(this).attr("data-swiper-slide-index")) !== undefined
            ? (this.progress || 0)
            : 0;

        var translate = progress * swiper.width * interleaveOffset;
        inner.style.transform = "translate3d(" + translate + "px, 0, 0)";
    });
}

    if (jQuery(".why-love-items .swiper").length) {
        var whyLoveItems = new Swiper('.why-love-items .swiper', {
            slidesPerView: 1.25,
            spaceBetween: 10,
            breakpoints: {
                560: {
                    slidesPerView: 2.25,
                },
                768: {
                    slidesPerView: 3.25,
                },
                1024: {
                    slidesPerView: 4
                },
            }
        });
    }

    if (jQuery("section.how-it-works .swiper").length) {
        var HowItWorks = new Swiper('section.how-it-works .swiper', {
            slidesPerView: 1.25,
            spaceBetween: 10,
            breakpoints: {
                560: {
                    slidesPerView: 2.25,
                },
                768: {
                    slidesPerView: 3.25,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 33.33,
                },
            }
        });
    }

    if (jQuery("section.sustainability .right-content .swiper").length) {
        var sustainability = new Swiper('section.sustainability .right-content .swiper', {
            slidesPerView: 1.75,
            spaceBetween: 10,
            breakpoints: {
                560: {
                    slidesPerView: 2.25,
                },
                768: {
                    slidesPerView: 3.25,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 9.33,
                },
            }
        });
    }

    if (jQuery('.exp-items-list .swiper').length) {
        var mosqiExplanation = new Swiper('.exp-items-list .swiper', {
            slidesPerView: 1.075,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.1,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                },
            },
        });
    }

    if ($('.related-blog-slider').length) {
        new Swiper('.related-blog-slider', {
        slidesPerView: 1.1,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
            768: {
            slidesPerView: 2,
            spaceBetween: 10
            },
            1024: {
            slidesPerView: 4,
            spaceBetween: 20
            }
        }
        });
    }

    // Read more - read less link in product page
    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".read-more-btn");
        if (!btn) return;

        e.preventDefault();

        const wrapper = btn.closest(".product-description-wrapper");
        const description = wrapper.querySelector(".product-description");

        description.classList.toggle("expanded");

        btn.textContent = description.classList.contains("expanded")
            ? "Read Less"
            : "Read More";
    });

    // Upsell products slider in product page
    document.addEventListener('DOMContentLoaded', () => {
        new Swiper('section.related-products.product-grid-container .upsell-swiper', {
            slidesPerView: 1.2,
            spaceBetween: 10,
            breakpoints: {
                768: {
                slidesPerView: 3,
                spaceBetween: 20,
                }
            }
        });
    });

// Showing filter always open 
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.mobile-facets__disclosure');
  drawer?.addEventListener('toggle', function () {
    if (this.open) {
      setTimeout(() => {
        this.querySelectorAll('.mobile-facets__details').forEach(detail => {
          detail.open = true;
        });
      }, 50);
    }
  });
});

// Toggle class in body tag when filter open
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.mobile-facets__disclosure');
  if (!drawer) return;
  drawer.addEventListener('toggle', function () {
    if (this.open) {
      // Drawer opened
      document.body.classList.add('filter-drawer-open');
      // Open all filter accordions
      this.querySelectorAll('.mobile-facets__details').forEach(function (detail) {
        detail.open = true;
      });
    } else {
      // Drawer closed
      document.body.classList.remove('filter-drawer-open');
    }
  });
});

//Added active class when select any language
document.addEventListener("DOMContentLoaded", function () {
  function setActiveLanguage() {
    document.querySelectorAll("#HeaderLanguageList .disclosure__item").forEach(li => {
      li.classList.toggle(
        "active",
        li.querySelector('.disclosure__link[aria-current="true"]')
      );
    });
  }
  setActiveLanguage();
  const list = document.getElementById("HeaderLanguageList");
  if (list) {
    new MutationObserver(setActiveLanguage).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-current"]
    });
  }
});


// Change thumbnail image & add active class in product page
document.addEventListener('click', function (e) {
  const item = e.target.closest('.variant-thumbnail-item');
  if (!item) return;
  const optionValue = item.dataset.optionValue;
  const radio = document.querySelector(
    `.product-form__input input[value="${CSS.escape(optionValue)}"]`
  );
  if (radio) {
    radio.click();
  }
});

document.addEventListener('change', function (e) {
  if (!e.target.matches('.product-form__input input[type="radio"]')) return;

  const value = e.target.value;
  document.querySelectorAll('.variant-thumbnail-item').forEach((item) => {
    item.classList.toggle(
      'active',
      item.dataset.optionValue === value
    );
  });
});

$(document).ready(function () {
    $('select._selectWrapper__select_1c3tu_9').select2({
        minimumResultsForSearch: Infinity // Hides the search box
    });
});